import React, { FormEvent, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Input from '../form-components/input/Input';
import { useAppContext } from '../../Contexts/AppContext';
import { EyeClosedIcon, EyeOpenIcon } from '@radix-ui/react-icons';
import Button from '../form-components/input/Button';

const ResetPassword: React.FC = () => {
  const { showPassword, showConfirmPassword, togglePasswordVisibility } =
    useAppContext();
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [newPassword, setnNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState<{
    code?: string;
    password?: string;
    confirmPassword?: string;
  }>({
    code: '',
    password: '',
    confirmPassword: '',
  });

  const location = useLocation();

  const resetPassword = async (e: FormEvent) => {
    e.preventDefault();

    if (!code) {
      setError({ code: 'Please enter verification code' });
    } else if (code.length !== 6) {
      setError({ code: 'Verification code must be 6 characters long' });
    } else if (!newPassword) {
      setError({ password: 'Please enter new password' });
    } else if (!confirmPassword) {
      setError({ confirmPassword: 'Please confirm new password' });
    } else if (confirmPassword !== newPassword) {
      setError({ confirmPassword: 'Password do not match' });
    } else {
      try {
        setStatus('loading');
        const response = await fetch(
          'https://backend-kyw8.onrender.com/reset-password',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              code,
              newPassword,
              confirmPassword,
              email: location?.state?.email,
            }),
          }
        );
        const data = await response.json();

        if (response.status === 400) {
          console.log(data.error)
          toast.error(data.error, {
            position: 'bottom-right',
          });
          setStatus('fail');
        } else {
          navigate('/login');
          toast.success(`Your password has been reset successfully!!!`, {
            position: 'bottom-right',
          });
          setStatus('success');
          setnNewPassword('');
          setConfirmPassword('');
          setError({
            code: '',
            password: '',
            confirmPassword: '',
          });
        }
      } catch (error) {
        console.log(error);
        setStatus('fail');
      }
    }
  };
  return (
    <div className='main-div'>
      <div className='form-div w-full flex flex-col gap-6 border border-[#222222] rounded-[20px]'>
        <h2 className='text-black font-semibold text-3xl text-center'>
          Reset Password
        </h2>

        <form onSubmit={resetPassword}>
          <div className='mb-2'>
            <Input
              label='Verification Code'
              type='text'
              id='code'
              value={code}
              placeholder='Enter verification code'
              onChange={(e) => setCode(e.target.value)}
              onBlur={() => setError({ code: '' })}
              errorText={error.code}
              required
            />
          </div>
          <div className='mb-2'>
            <Input
              label='New Password'
              type={showPassword ? 'text' : 'password'}
              id='password'
              value={newPassword}
              placeholder='Enter new password'
              onChange={(e) => setnNewPassword(e.target.value)}
              onBlur={() => setError({ password: '' })}
              errorText={error.password}
              withPassword
              passwordIcon={
                showPassword ? (
                  <EyeOpenIcon className='h-8' />
                ) : (
                  <EyeClosedIcon className='h-8' />
                )
              }
              toggleInputType={() => togglePasswordVisibility('password')}
              required
            />
          </div>

          <div className='mb-2'>
            <Input
              label='Confirm New Password'
              type={showConfirmPassword ? 'text' : 'password'}
              id='password'
              value={confirmPassword}
              placeholder='Confirm new password'
              onChange={(e) => setConfirmPassword(e.target.value)}
              onBlur={() => setError({ confirmPassword: '' })}
              errorText={error.confirmPassword}
              withPassword
              passwordIcon={
                showConfirmPassword ? (
                  <EyeOpenIcon className='h-8' />
                ) : (
                  <EyeClosedIcon className='h-8' />
                )
              }
              toggleInputType={() =>
                togglePasswordVisibility('confirm-password')
              }
              required
            />
          </div>

          <Button
            type='submit'
            isLoading={status === 'loading'}
            buttonText='Reset Password'
          />
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
